export const FooterData = [
  {
    title: "Quick Links",
    subtitle: "Navigate with quick links below",
    isExternal: false,
    links: [
      {
        name: "Home",
        link: "#",
      },
      {
        name: "Contact",
        link: "#",
      },
      {
        name: "Careers",
        link: "#",
      },
    ],
  },
  {
    title: "Social Links",
    subtitle: "Lets get connected",
    isExternal: true,
    links: [
      {
        name: "Github",
        link: "https://github.com/FarhanMobashir",
      },
      {
        name: "Twitter",
        link: "https://twitter.com/MobashirFarhan",
      },
    ],
  },
];
